import { render } from "./CompanyIcons.vue?vue&type=template&id=146014ec&scoped=true"
import script from "./CompanyIcons.vue?vue&type=script&lang=js"
export * from "./CompanyIcons.vue?vue&type=script&lang=js"

import "./CompanyIcons.vue?vue&type=style&index=0&id=146014ec&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146014ec"]])

export default __exports__